import licenseList from "../licenses/licenseDetails.json";
export const licensingData = [...licenseList];
